import { isElectron } from '@/app/nativeBridge';

export const DOCUMENTATION_URL = 'https://docs.quadratichq.com';
export const QUADRATIC_FOR_EDUCATION = `${DOCUMENTATION_URL}/quadratic-for-education`;
export const DOCUMENTATION_PYTHON_URL = `${DOCUMENTATION_URL}/python`;
export const DOCUMENTATION_FORMULAS_URL = `${DOCUMENTATION_URL}/formulas`;
export const DOCUMENTATION_JAVASCRIPT_URL = `${DOCUMENTATION_URL}/javascript`;
export const DOCUMENTATION_JAVASCRIPT_RETURN_DATA = `${DOCUMENTATION_URL}/javascript/return-data-to-the-sheet`;
export const DOCUMENTATION_FILES_URL = `${DOCUMENTATION_URL}/spreadsheet/files`;
export const DOCUMENTATION_OFFLINE = `${DOCUMENTATION_URL}/spreadsheet/files#local-saving`;
export const DOCUMENTATION_CONNECTIONS_URL = `${DOCUMENTATION_URL}/connections`;
export const DOCUMENTATION_CONNECTIONS_IP_LIST_URL = `${DOCUMENTATION_CONNECTIONS_URL}/security#ip-allow-list`;
export const DOCUMENTATION_CONNECTIONS_DATABASE_ACCESS_URL = `${DOCUMENTATION_CONNECTIONS_URL}/security#database-access`;
export const DOCUMENTATION_CONNECTIONS_GOOGLE_ANALYTICS_URL = `${DOCUMENTATION_CONNECTIONS_URL}/google-analytics`;
export const DOCUMENTATION_CONNECTIONS_MIXPANEL_URL = `${DOCUMENTATION_CONNECTIONS_URL}/mixpanel`;
export const DOCUMENTATION_CONNECTIONS_QUICKBOOKS_URL = `${DOCUMENTATION_CONNECTIONS_URL}/quickbooks`;
export const DOCUMENTATION_BROWSER_COMPATIBILITY_URL = `${DOCUMENTATION_URL}/spreadsheet/browser-compatibility`;
export const DOCUMENTATION_DATE_TIME_FORMATTING = `${DOCUMENTATION_URL}/spreadsheet/date-time-formatting`;
export const DOCUMENTATION_NEGATIVE_OFFSETS = `${DOCUMENTATION_URL}/spreadsheet/negative-offsets`;
export const DOCUMENTATION_ANALYTICS_AI = `${DOCUMENTATION_URL}/quadratic-ai/security`;
export const DOCUMENTATION_SCHEDULED_TASKS_URL = `${DOCUMENTATION_URL}/spreadsheet/scheduled-tasks`;
export const DOCUMENTATION_CRON = `${DOCUMENTATION_URL}/spreadsheet/scheduled-tasks`;
export const DOCUMENTATION_EMBED_URL = `${DOCUMENTATION_URL}/spreadsheet/embed`;
export const TRUST_CENTER = 'https://trust.quadratichq.com';
export const BUG_REPORT_URL = 'https://github.com/quadratichq/quadratic/issues';
export const TWITTER = 'https://twitter.com/quadratichq';
export const CONTACT_URL = 'https://quadratichq.com/contact';
export const WEBSITE_CONNECTIONS = 'https://www.quadratichq.com/connections';
export const WEBSITE_EXAMPLES = 'https://www.quadratichq.com/examples';
export const WEBSITE_CHANGELOG = 'https://www.quadratichq.com/changelog';
export const SCHEDULE_MEETING = 'https://calendly.com/d/ckz9-g8t-stb/quadratic-demo';
export const COMMUNITY_A1_FILE_UPDATE_URL =
  'https://community.quadratichq.com/t/switch-to-a1-notation-from-x-y-coordinates/';
export const PRICING_URL = 'https://www.quadratichq.com/pricing';
export const YOUTUBE_CHANNEL = 'https://www.youtube.com/@quadraticai';

// Destination for mobile users when a file is too large to open in a mobile
// browser, or when the browser runs out of memory. Today this points at the
// main desktop web app; once the native (Cordova) app ships, update this to
// the relevant App Store / Play Store link. `MOBILE_APP_CTA_LABEL` also
// describes what we're pointing users at, which is surfaced in UI copy.
export const MOBILE_APP_CTA_URL = 'https://app.quadratichq.com';
export const MOBILE_APP_CTA_LABEL = 'desktop';

const DEFAULT_PUBLIC_WEB_APP_ORIGIN = 'https://app.quadratichq.com';

/**
 * Origin for share/embed links. In Electron the SPA runs on `app://localhost`, so
 * we use the build-time public web origin; in the browser we use the current host.
 */
export function getShareableWebAppOrigin(): string {
  if (!isElectron()) {
    return window.location.origin;
  }
  const raw = import.meta.env.VITE_PUBLIC_WEB_APP_ORIGIN;
  if (typeof raw === 'string' && raw.trim()) {
    try {
      const u = new URL(raw.trim());
      return `${u.protocol}//${u.host}`;
    } catch {
      return DEFAULT_PUBLIC_WEB_APP_ORIGIN;
    }
  }
  return DEFAULT_PUBLIC_WEB_APP_ORIGIN;
}
